export default () => ({
  show: false,
  statusAddress: null,
  prefixRouter: 'professional.covenants',
  entity: 'covenant',
  entities: 'covenants',
  plansOptions: [],
  covenants: [],
  includes: ['covenant', 'company', 'total_plans_served'],
  activeOptions: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  nextStepButtonAddress: [
    {
      icon: '',
      text: 'Cadastrar Local de Atendimento',
      name: 'professional.company.addresses.create'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/data.js